// extracted by mini-css-extract-plugin
export default {"wrapper":"sidemenu_wrapper__g6UhY","sidebar":"sidemenu_sidebar__2WKYz","icon":"sidemenu_icon__4Nvpp","active":"sidemenu_active__DEQm1","profile":"sidemenu_profile__PF26q"};